import { defineStyleConfig } from '@chakra-ui/react'
import type { StyleFunctionProps } from '@chakra-ui/theme-tools'
import { mode } from '@chakra-ui/theme-tools'

const baseStyle = (props: StyleFunctionProps) => ({
  fontSize: '13px',
  fontWeight: '400',
  margin: 0,
  color: mode('grey02', 'darkGrey02')(props),
})

export const FormLabel = defineStyleConfig({
  baseStyle,
})
